<template>
  <div class="index">
    <div class="index-header">
      <el-form :model="form" :inline="true" label-width="110px">
        <div class="input-box" v-show="!out" style="margin-bottom: 18px">
          <div>
            <el-form-item label="企业名称：" prop="name">
              <el-input v-model="form.organizationName" placeholder="请输入企业名称"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入电话"></el-input>
            </el-form-item>
          </div>
          <div>
            <label style="margin:5px 10px 0 30px;">地区：</label>
          </div>
          <div style="margin-right:10px">
            <Area :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1"/>
          </div>
          <div style="margin-right:10px">
            <el-form-item label="开始时间：" prop="startCreateTime">
              <el-date-picker type="date" v-model="form.startCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
            <el-form-item label="结束时间：" prop="endCreateTime">
              <el-date-picker type="date" v-model="form.endCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button
                type="primary" icon="el-icon-search"
                @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                Filter_file({api:api,data:form,callback:_d => tableData = _d })">查询</el-button>
            </el-form-item>
          </div>
        </div>
        <div class="input-box" v-show="out">
          <div>
            <label style="margin:5px 10px 0 30px;">地区：</label>
          </div>
          <div style="margin-bottom:10px">
            <Area   :value="area_data"
                :diss="dis"
                :arr="arrPlace2"
                @getPlace="getPlace2"/>
          </div>
          <div>
            <el-form-item label="统计开始时间：">
              <el-date-picker
                style="width:193px;"
                v-model="form1.startTime"
                value-format="timestamp"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="统计结束时间：">
              <el-date-picker
                style="width:193px;"
                v-model="form1.endTime"
                value-format="timestamp"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary"
                     @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                    Filter_file({api:`${api}/report`,data:form1,callback:_d => tableData1 = _d })"
                     icon="el-icon-search">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="edit" v-show="!out">
      <el-button :disabled="selectRow.length==1?false:true" v-if="showBtn[1].isShow" icon="el-icon-edit" @click="openBox('edit')">编辑</el-button>
      <el-button icon="el-icon-edit" v-if="showBtn[3].isShow" @click="openBox('create')">创建</el-button>
      <el-button icon="el-icon-delete" v-if="showBtn[2].isShow" type="danger" @click="deleteDate('gwcctjb')">删除</el-button>
      <el-button style="padding: 0" v-if="showBtn[4].isShow"><file_Upload :_url="$public.upload_url._g"></file_Upload></el-button>
      <el-button type="primary" @click="downShow = true" icon="el-icon-document-remove">
        <!-- <a style="color:#fff" href="../model/岗位抽查统计表--导入.xls" download="岗位抽查统计表.xls">下载模板</a> -->
        下载模板
      </el-button>
    </div>
    <el-button type="primary" v-if="showBtn[5].isShow" @click="out = !out" icon="el-icon-document-remove">{{out===false?'导出报表':'数据采集'}}</el-button>
    <div class="edit" v-show="out">
      <el-button type="primary" v-loading.fullscreen.lock="lodaingTime" @click="Filter_export(`${api}/export`,form)" icon="el-icon-document-remove">导出数据</el-button>
    </div>
    <div class="table" v-show="!out">
      <el-table
        :data="tableData"
        border
        max-height="550"
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-for="(item,index) in baseInfo"
          :key="index"
          :prop="item.key"
          :fixed="index>7?false:true"
          :label="item.value"
          align="center">
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <div class="table" v-show="out">
      <el-table
        :data="tableData1"
        border
        max-height="550"
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          show-overflow-tooltip
          prop="areaName"
          label="行政区域"
          align="center">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="totalCount"
          label="任务总数"
          align="center">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="抽查结果"
          align="center">
          <el-table-column
            show-overflow-tooltip
            v-for="(item,index) in baseInfo1"
            :key="index"
            :prop="item.key"
            :label="item.value"
            align="center">
          </el-table-column>
          <el-table-column
            label="岗位信息错误"
            align="center">
            <el-table-column
              show-overflow-tooltip
              v-for="(item,index) in baseInfo2"
              :key="index"
              :prop="item.key"
              :label="item.value"
              align="center">
            </el-table-column>
          </el-table-column>
          <el-table-column
            label="未接通"
            align="center">
            <el-table-column
              show-overflow-tooltip
              v-for="(item,index) in baseInfo3"
              :key="index"
              :prop="item.key"
              :label="item.value"
              align="center">
            </el-table-column>
          </el-table-column>
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <!-- 模态框 -->
    <el-dialog
      title="岗位抽查统计表"
      :visible.sync="centerDialogVisible"
      @close="close"
      :modal="false"
      width="1400px"
      :close-on-click-modal="false"
      center>
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">基本信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" :rules="rules" ref="editForm" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="地区：">
                          <Area   :value="area_data"
                              :diss="dis"
                              :name="arrPlace"
                              @getPlace="getPlace"/>
                        </el-form-item>
                        <el-form-item label="岗位名称：">
                          <el-input style="width:193px;" v-model="editForm.jobName"></el-input>
                        </el-form-item>
                        <el-form-item prop="organizationName" label="企业名称：">
                          <el-input style="width:193px;" v-model="editForm.organizationName"></el-input>
                        </el-form-item>
                        <el-form-item label="联系人：">
                          <el-input style="width:193px;" v-model="editForm.contactUser"></el-input>
                        </el-form-item>
                        <el-form-item prop="phone" label="联系电话：">
                          <el-input style="width:193px;" v-model="editForm.phone"></el-input>
                        </el-form-item>
                        <el-form-item prop="checkArea" label="抽查地区：">
                          <el-input style="width:193px;" v-model="editForm.checkArea"></el-input>
                        </el-form-item>
                        <el-form-item label="抽查结果：">
                          <el-select size="mini" filterable v-model="editForm.checkResult" placeholder="请选择">
                            <el-option
                              v-for="item in $public.chouchajieguo"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="其它原因：">
                          <el-input style="width:193px;" v-model="editForm.otherReason"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="工作地：">
                          <el-input style="width:193px;" v-model="editForm.workAddress"></el-input>
                        </el-form-item>
                        <el-form-item label="招聘人数：">
                          <el-input style="width:193px;" v-model="editForm.needPersons"></el-input>
                        </el-form-item>
                        <el-form-item label="专岗类型：">
                          <el-select size="mini" filterable v-model="editForm.jobType" placeholder="请选择">
                            <el-option
                              v-for="item in $public.zhuangangleixing"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="截至日期：">
                          <el-date-picker
                            style="width:193px;"
                            v-model="editForm.endTime"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="最低月薪：">
                          <el-input style="width:193px;" v-model="editForm.minSalary"></el-input>
                        </el-form-item>
                        <el-form-item label="最高月薪：">
                          <el-input style="width:193px;" v-model="editForm.maxSalary"></el-input>
                        </el-form-item>
                        <el-form-item label="岗位发布日期：">
                          <el-date-picker
                            style="width:193px;"
                            v-model="editForm.publicTime"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="录入单位：">
                          <el-input style="width:193px;" v-model="editForm.importOrganization"></el-input>
                        </el-form-item>
                        <el-form-item label="操作人：">
                          <el-input style="width:193px;" v-model="editForm.dealUser"></el-input>
                        </el-form-item>
                        <el-form-item label="操作日期：">
                          <el-date-picker
                            style="width:193px;"
                            v-model="editForm.dealTime"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <dowmloadplace :value="type" :downShow="downShow" @cutOff="cutOff"/>
  </div>
</template>
<script>
import mixins from '@/Mixins'
export default {
  mixins:[mixins],
  data() {
    return{
      api:'/user/jobCheck',
      form:{},
      type:'24',
      isCreate:false,
      out:false,
      centerDialogVisible:false,
      tableData:[],
      tableData1:[],
      selectRow:[],
      baseInfo:[
        {key: 'province', value: '省'},
        {key: 'city', value: '市'},
        {key: 'county', value: '县'},
        {key: 'town', value: '镇'},
        {key: 'village', value: '村'},
        {key:'jobName',value:'岗位名称'},
        {key:'organizationName',value:'企业名称'},
        {key:'contactUser',value:'联系人'},
        {key:'phone',value:'联系电话'},
        {key:'checkArea',value:'抽查地区'},
        {key:'checkResult',value:'抽查结果'},
        {key:'otherReason',value:'其它原因'},
        {key:'workAddress',value:'工作地'},
        {key:'needPersons',value:'招聘人数'},
        {key:'jobType',value:'专岗类型'},
        {key:'endTime',value:'截至日期'},
        {key:'minSalary',value:'最低月薪'},
        {key:'maxSalary',value:'最高月薪'},
        {key:'publicTime',value:'岗位发布日期'},
        {key:'importOrganization',value:'录入单位'},
        {key:'dealUser',value:'操作人'},
        {key:'dealTime',value:'操作时间'},
      ],
      baseInfo1:[
        {key: 'taskDoneCount', value: '已抽查总数'},
        {key: 'matchCount', value: '信息相符'},
        {key: 'matchPercent', value: '信息相符占比'},
      ],
      baseInfo2:[
        {key: 'jobInfoMismatch', value: '岗位信息错误'},
        {key: 'jobFull', value: '岗位已招满'},
        {key: 'noSuchJob', value: '企业无此岗位'},
      ],
      baseInfo3:[
        {key: 'unconnectStop', value: '停机'},
        {key: 'unconnectEmpty', value: '空号'},
        {key: 'unconnectClose', value: '关机'},
        {key: 'unconnectNoanswer', value: '无人应答'},
        {key: 'unconnectNowish', value: '不配合调查'},
        {key:'unconnectOther',value:'其它'},
      ],
      rules:{
        organizationName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
      },
    }
  },
  created() {
    this.isShowBtn("JobCheck")//控制操作按钮的显示与隐藏
    this.getArea({value:{areaId:0},key:0})
  },
  methods:{
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //分页
    get_page_number(pageNumer) {
      let [vm] = [this]
      vm.form.pageNumber = pageNumer;
      vm.Filter_file({api:vm.api,data:vm.form,callback:_d => vm.tableData = _d})
    },
    //提交请求
    submit() {
      let newForm = {}
      newForm = JSON.parse(JSON.stringify(this.editForm))
      delete newForm.areaId
      
      newForm.endTime = new Date(newForm.endTime).getTime()
      newForm.publicTime = new Date(newForm.publicTime).getTime()
      newForm.dealTime = new Date(newForm.dealTime).getTime()
      newForm.province = this.province
      newForm.city = this.city
      newForm.county = this.county
      newForm.town = this.town
      newForm.village = this.village
      this.$refs['editForm'].validate((valid)=>{
        if (valid && this.isCreate === true) {
          this.$api.create(this.api,newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('创建成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
              
            } else {
							this._status(res.data)
						}
          })
        } else if (valid && this.isCreate === false) {
          delete newForm.createTime
          this.$api.change(`${this.api}/modify`,newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('修改成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
              
            } else {
							this._status(res.data)
						}
          })
        } else {
          return false
        }
      })
    },
  }
}
</script>
<style>
/* .index .index-header .el-form-item__content{width: 200px;} */
.input-box{display:flex;flex-direction: row;justify-content: flex-start;}
.input-box>div{display:flex;flex-direction: column;}



</style>